import NotificationCenter from 'features/NotificationCenter'
import DirectfulAssist from 'features/DirectfulAssist'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'

import Header from '../components/_Header'
import LoadingIndicator from '../components/ReusableComponents/LoadingIndicator'
import Sidebar from '../components/Sidebar'

const Wrapper = ({ children }) => <div className="content-wrapper">{children}</div>
const Container = ({ children }) => <div className="flex-container">{children}</div>
const Content = ({ children }) => <div className="dashboard-content">{children}</div>

const EnsureLoggedInContainer = ({
  userLoggedIn,
  sessionExpired,
  children,
  tryingLogIn,
  location,
  currentHotel,
  pathName,
  isSubsidiaryPosted,
  documentTitle
}) => {
  const [notificationCenterOpen, setNotificationCenterOpen] = useState()

  useEffect(() => {
    document.title = documentTitle
  }, [documentTitle])

  if (tryingLogIn) {
    return <LoadingIndicator />
  }

  if (!userLoggedIn || sessionExpired) {
    return <Redirect to={`/login`} />
  }

  if (userLoggedIn && !currentHotel && !pathName.includes('selectHotel')) {
    return <div>not rendering</div>
  }

  if (!isSubsidiaryPosted && !pathName.includes('selectHotel')) {
    return <LoadingIndicator />
  }

  if (userLoggedIn && pathsWithoutSidebar.includes(location.pathname.split('/')[1])) {
    return children
  }

  if (
    userLoggedIn &&
    pathsWithoutContainer.includes(location.pathname.split('/')[1])
  ) {
    return (
      <Container>
        <Sidebar />
        <NotificationCenter
          visible={notificationCenterOpen}
          handleHide={() => setNotificationCenterOpen(false)}
        />
        <DirectfulAssist />
        <Wrapper>
          <Header handleOpenNotificationCenter={() => setNotificationCenterOpen(true)} />
          {children}
        </Wrapper>
      </Container>
    )
  }

  if (userLoggedIn) {
    return (
      <Container>
        <Sidebar />
        <NotificationCenter
          visible={notificationCenterOpen}
          handleHide={() => setNotificationCenterOpen(false)}
        />
        <DirectfulAssist />
        <Wrapper>
          <Header handleOpenNotificationCenter={() => setNotificationCenterOpen(true)} />
          <Content>{children}</Content>
        </Wrapper>
      </Container>
    )
  }

  return 'something went wrong'
}

const mapStateToProps = ({ login, router, header }) => {
  return {
    userLoggedIn: login.userLoggedIn,
    tryingLogIn: login.tryingLogIn,
    sessionExpired: login.sessionExpired,
    currentHotel: login.currentHotel,
    pathName: router.location.pathname,
    isSubsidiaryPosted: login.isSubsidiaryPosted,
    documentTitle: header.documentTitle
  }
}

const pathsWithoutSidebar = [
  'guestDetails',
  'reviewDetails',
  'statement',
  'invoice',
  'bookingHistory',
  'selectHotel',
  'tutorial',
  'operaSetup',
  'hotel-setup',
  'initial'
]

const pathsWithoutContainer = [
  'hotels',
  'newHotel',
  'editHotel',
  'aiTraining',
  'messaging',
  'incoming',
  'feedback',
  'direct',
  'announcements',
  'dailyConversations',
  'message-subscribers'
]

export default withRouter(connect(mapStateToProps)(EnsureLoggedInContainer))
